import angular from 'angular';

class ModalDeletePrincipalCtrl {
  /*@ngInject*/
  constructor(PrincipalSvc, logger) {
    this.PrincipalSvc = PrincipalSvc;
    this.logger = logger;
  }

  $onInit() {
    this.principal = angular.copy(this.resolve.principal);
  }

  deletePrincipal() {
    this.PrincipalSvc.deletePrincipal(this.principal.id).then(
      data => {
        this.logger.success('success.delete', data, null, { entityName: this.principal.corporateName });
        this.modalInstance.close();
      },
      () => {
        this.logger.error('error.delete');
        this.cancel();
      }
    );
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }
}

angular.module('app.principal').component('modalDeletePrincipal', {
  templateUrl: require('./modal-delete-principal.html'),
  controller: ModalDeletePrincipalCtrl,
  bindings: {
    resolve: '<',
    modalInstance: '<'
  }
});
